import { Wand2, MessageSquareReply } from "lucide-react";
import { TRANSLATIONS } from "@/i18n";

export const ModeSwitcher = ({ lang, mode, onChange }) => {
  const t = TRANSLATIONS[lang];
  return (
    <div className="mb-10 sm:mb-12">
      <SectionLabel text={t.sectionModeLabel} />
      <div className="grid sm:grid-cols-2 gap-4">
        <ModeCard
          active={mode === "reformulate"}
          onClick={() => onChange("reformulate")}
          icon={<Wand2 className="w-4 h-4" strokeWidth={2.5} />}
          title={t.modeReformulate}
          desc={t.modeReformulateDesc}
          color="#B5EAD7"
          testId="mode-reformulate"
        />
        <ModeCard
          active={mode === "reply"}
          onClick={() => onChange("reply")}
          icon={<MessageSquareReply className="w-4 h-4" strokeWidth={2.5} />}
          title={t.modeReply}
          desc={t.modeReplyDesc}
          color="#FFDAC1"
          testId="mode-reply"
        />
      </div>
    </div>
  );
};

const SectionLabel = ({ text }) => (
  <div className="flex items-center gap-3 mb-4">
    <span className="dossier-tag font-bold">{text}</span>
    <span className="flex-1 h-px bg-black/15" />
  </div>
);

const ModeCard = ({ active, onClick, icon, title, desc, color, testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    aria-pressed={active}
    className={`text-left border-2 border-black p-5 transition-all relative ${
      active
        ? "nb-shadow -translate-x-0.5 -translate-y-0.5"
        : "bg-white nb-shadow-sm hover:-translate-x-0.5 hover:-translate-y-0.5 hover:nb-shadow"
    }`}
    style={active ? { background: color } : undefined}
  >
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-3">
        <div className="w-7 h-7 bg-white border-2 border-black flex items-center justify-center">
          {icon}
        </div>
        <h3 className="font-display font-semibold text-2xl sm:text-3xl leading-tight tracking-tight">
          {title}
        </h3>
      </div>
      {active && (
        <span
          className="font-mono text-[10px] uppercase tracking-widest border border-black px-1.5 py-0.5 bg-white"
          aria-hidden
        >
          ✓ sélectionné
        </span>
      )}
    </div>
    <p className="text-sm text-[#4A4A4A] leading-relaxed pl-10">{desc}</p>
  </button>
);
